import React, { useEffect, useReducer } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";

import LearningContentsContext from '../../../context/learningContentContext/learningContents-context';
import learningContentReducer from '../../../reducers/learningContent-reducer';
import { GetNonTraitLearningContents } from '../../../actions/learningcontent-actions';
import NonTraitLearningContentHolder from '../nonTrait/NonTraitLearningContentHolder';
import { DefaultLayout, BreadcrumbsCustom } from '../../shared/component'

import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper';
import { getLearningContentFromSession } from '../../../utils/helpers/others/SessionHelper';
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'

const NonTraitLearningContents = () => {
    const classes = useStyles()
    const history = useHistory();
    const [learningContentsContext, dispatch] = useReducer(learningContentReducer);
    const learningContentSession = JSON.parse(getLearningContentFromSession());

    useEffect(() => {
        const initLearningContents = async () => {
            const learningContentsResponse = await GetNonTraitLearningContents();
            if (learningContentsResponse > 200 || learningContentsResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            let learningContentsVar = learningContentsResponse.data;
            dispatch({ type: 'SET_NONTRAIT_LEARNING_CONTENTS', nonTraitLearningContents: learningContentsVar.nonTraitLearningContents });
        }

        initLearningContents();
    }, []);

    const breadcrumbsData = [
        {
            text: 'Learning Resources',
            href: '/LearningContentCategories'
        },
        {
            text: learningContentSession.learningContentCategoryName,
            href: ''
        },
    ];

    return (
        <LearningContentsContext.Provider value={{ learningContentsContext, dispatch }}>

            <DefaultLayout
                title={learningContentSession.learningContentCategoryName}
                type='Learning Content'
                description='Please choose a learning resource'
                image={getIconLearningContent().img_lc_bg_header}
            >
                <Grid container>
                    <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} >

                    </Grid>
                    <Grid item xs={12} md={6} classes={{ root: classes.rootGridContentContainer }}>
                        <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                        <NonTraitLearningContentHolder />
                    </Grid>
                </Grid>

            </DefaultLayout>
        </LearningContentsContext.Provider>
    )
};

export default NonTraitLearningContents;